import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdumoeftService } from 'src/app/services/adumoeft/adumoeft.service';
import {HttpErrorResponse} from "@angular/common/http";
import {AdumoEftPaymentUpdateRequest} from "../../../interfaces/adumoeft/Adumoeft";

@Component({
  selector: 'app-adumoeft-callback',
  templateUrl: './adumoeft-callback.component.html',
  styleUrls: ['./adumoeft-callback.component.scss']
})
export class AdumoeftCallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute, private adumoeftService: AdumoeftService, private router: Router, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
  }

  adumoEftPaymentUpdateRequest: AdumoEftPaymentUpdateRequest
  confirmed: boolean = false;
  mobile;
  cardSvgEl;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.adumoEftPaymentUpdateRequest = {
          id: params.id,
          status: params.status,
          externalReference: params.externalReference
        }
      this.adumoeftService.getTransactionStatus(this.adumoEftPaymentUpdateRequest.externalReference, this.adumoEftPaymentUpdateRequest)
      .subscribe(
        value => {
          this.confirmed = true;
          this.navigateToStatus();
        }, (err: HttpErrorResponse) => {
          this.navigateToStatus();
        }
      );
      }
    );
  }


  navigateToStatus() {
    this.router.navigate(
      [`transaction-status`]);
  }

}
